const IMAGE_API_BASE = 'https://image-gen-drd3.onrender.com';

export interface ImageGenerationParams {
  prompt: string;
  steps: number;
  guidance: number;
  width: number;
  height: number;
  seed: number;
}

export interface ImageGenerationResponse {
  status: string;
  prompt: string;
  image_url: string;
  parameters: {
    steps: number;
    guidance: number;
    width: number;
    height: number;
    seed: number;
  };
}

export const generateImage = async (
  params: ImageGenerationParams
): Promise<ImageGenerationResponse> => {
  const response = await fetch(`${IMAGE_API_BASE}/generate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    if (response.status === 429) {
      throw new Error('Too many requests. Please wait a moment.');
    }
    const errorData = await response.json().catch(() => null);
    throw new Error(errorData?.detail || `Server error (${response.status})`);
  }

  return response.json();
};

export const getImageUrl = (imagePath: string): string => {
  if (imagePath.startsWith('http')) return imagePath;
  return `${IMAGE_API_BASE}${imagePath}`;
};

export const DEFAULT_PARAMS: ImageGenerationParams = {
  prompt: '',
  steps: 20,
  guidance: 7.5,
  width: 512,
  height: 512,
  seed: -1,
};

export const SIZE_PRESETS = [
  { label: '512×512', width: 512, height: 512, icon: '◻️' },
  { label: '768×512', width: 768, height: 512, icon: '▬' },
  { label: '512×768', width: 512, height: 768, icon: '▮' },
  { label: '768×768', width: 768, height: 768, icon: '⬜' },
  { label: '1024×1024', width: 1024, height: 1024, icon: '🖼️' },
];